import banner from "../../../courses/module-2/img4.png";

const modulo4_pt = {
  courseId: "cripto-blockchain",
  id: "modulo-4",
  title: "🧩 MÓDULO 4: Stablecoins, Tokens e o Mundo Real do Cripto",
  estimatedDuration: "1 hora",
  format: "Leitura + atividade de verificação",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 O que você vai aprender neste módulo?",
      content: [
        "O que é uma stablecoin e por que elas são essenciais no ecossistema Web3.",
        "A diferença entre tokens e moedas nativas.",
        "O papel real de USDT, USDC, DAI e XLM.",
        "Exemplos reais de uso em trading, pagamentos, remessas e poupança.",
        "Como evitar erros comuns ao enviar criptos por redes diferentes.",
      ],
    },
    {
      id: "conceptos-clave",
      navLabel: "Conceitos-chave",
      title: "📚 Conceitos-chave",
      content: [
        {
          type: "paragraph",
          text: "🟡 O que é uma stablecoin?",
        },
        {
          type: "paragraph",
          text: "Uma stablecoin é uma criptomoeda criada para manter um valor estável, geralmente atrelada a uma moeda tradicional como o dólar ou o euro. Elas funcionam como uma ponte entre o dinheiro tradicional e o mundo cripto.",
        },
        {
          type: "paragraph",
          text: "Exemplos populares:",
        },
        {
          type: "list",
          items: [
            "USDT (Tether): A mais utilizada, mas criticada pela falta de transparência nas reservas.",
            "USDC (USD Coin): Emitida pela Circle, com garantia 100% em dólares.",
            "DAI: Stablecoin descentralizada mantida pelo protocolo MakerDAO, colateralizada em outras criptos.",
          ],
        },
        {
          type: "paragraph",
          text: "🧾 O que é um token?",
        },
        {
          type: "paragraph",
          text: "Um token é um ativo digital criado em cima de uma blockchain já existente.",
        },
        {
          type: "paragraph",
          text: "Por exemplo: USDT pode existir na rede Ethereum, Tron, Polygon, Solana, etc.",
        },
        {
          type: "paragraph",
          text: "🔗 E o que é uma moeda nativa?",
        },
        {
          type: "paragraph",
          text: "É a criptomoeda própria de uma blockchain.",
        },
        {
          type: "list",
          items: ["BTC → Bitcoin", "ETH → Ethereum", "XLM → Stellar"],
        },
        {
          type: "paragraph",
          text: "Ela é necessária para pagar taxas de rede (fees ou gas).",
        },
      ],
    },
    {
      id: "nota",
      navLabel: "Nota importante",
      title: "⚠️ IMPORTANTE — Não confunda rede, token e criptomoeda",
      content: [
        {
          type: "paragraph",
          text: "Criptos como USDT e USDC existem em várias redes diferentes.",
        },
        {
          type: "paragraph",
          text: "Se você enviar por uma rede errada, pode perder tudo para sempre.",
        },
        {
          type: "paragraph",
          text: "Antes de enviar, sempre verifique:",
        },
        {
          type: "list",
          items: [
            "A rede correta",
            "Se a outra pessoa ou plataforma aceita essa rede",
            "Se o token é compatível com a rede escolhida",
          ],
        },
        {
          type: "paragraph",
          text: "🧠 No mundo Web3, você é o responsável pelos seus fundos. Não existe botão “cancelar”.",
        },
      ],
    },
    {
      id: "ejemplos-reales",
      navLabel: "Exemplos",
      title: "🌐 Exemplos do mundo real",
      content: [
        {
          type: "list",
          items: [
            "USDC na rede Stellar: usado por ONGs para enviar ajuda humanitária com taxas quase zero.",
            "USDT na Binance ou KuCoin: usado como moeda base em negociações.",
            "DAI em protocolos DeFi: permite pegar empréstimos e gerar rendimento sem bancos.",
            "XLM em MoneyGram: agiliza remessas internacionais na América Latina.",
          ],
        },
      ],
    },
    {
      id: "recursos",
      navLabel: "Recursos",
      title: "📌 Recursos recomendados",
      content: [
        {
          type: "link",
          href: "https://www.binance.com/pt-BR/academy/articles/what-is-a-stablecoin",
          text: "Binance Academy – O que é uma stablecoin?",
        },
        {
          type: "link",
          href: "https://coinext.com.br/criptomoedas/usd-coin",
          text: "CoinNext – O que é USDC?",
        },
        {
          type: "link",
          href: "https://www.binance.com/pt-BR/academy/courses/track/blockchain-and-p2p-fundamentals/Introduction-to-trading-mining-digital-crypto-currencies-and-tokens",
          text: "Binance Academy – Tokens vs Coins",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Atividade",
      title: "📝 Atividade: tabela comparativa + reflexão",
      content: [
        {
          type: "paragraph",
          text: "🔧 Instruções",
        },
        {
          type: "paragraph",
          text: "Preencha a seguinte tabela com base no que aprendeu:",
        },
        {
          type: "table",
          headers: [
            "Nome",
            "Tipo (moeda ou stablecoin)",
            "Quem emite?",
            "Rede principal",
            "Para que serve?",
            "Nível de risco",
          ],
          rows: [
            ["USDT", "", "", "", "", ""],
            ["USDC", "", "", "", "", ""],
            ["DAI", "", "", "", "", ""],
            ["XLM", "", "", "", "", ""],
          ],
        },
        {
          type: "paragraph",
          text: "🗨️ Conclusão",
        },
        {
          type: "paragraph",
          text: "Qual delas parece mais útil ou segura para um iniciante? Por quê?",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase",
      title: "🧠 Frase do dia",
      content: [
        "“Entender o valor real de uma moeda é mais importante do que saber quanto ela custa.”",
      ],
    },
  ],
};

export default modulo4_pt;
